// Wire values must match the Lambda's ALLOWED_CATEGORIES in
// cloud/support-submit/src/types.ts. The Lambda maps them to Jira issue types
// (Bug / New Feature / Task) — see issueTypeForCategory in jira.ts.

export const CONTACT_CATEGORIES = [
  { value: 'BUG', label: 'Report a problem' },
  { value: 'FEATURE_REQUEST', label: 'Suggest an improvement' },
  { value: 'QUESTION', label: 'Ask a question' },
  { value: 'SUPPORT', label: 'Request support' },
  { value: 'BILLING', label: 'Billing & payments' },
  { value: 'ORDER_EQUIPMENT', label: 'Order equipment' },
  { value: 'OTHER', label: 'Something else' },
] as const;

export type ContactCategoryValue = (typeof CONTACT_CATEGORIES)[number]['value'];

// Patient-facing subset. Reuses existing wire values (the Lambda only accepts
// ALLOWED_CATEGORIES) with plain-language labels — patients don't see the
// clinician-facing Bug / Feature / Billing / Equipment options. Labels are a
// first-cut placeholder pending CS sign-off.
export const PATIENT_CONTACT_CATEGORIES: ReadonlyArray<{
  value: ContactCategoryValue;
  label: string;
}> = [
  { value: 'QUESTION', label: 'Help using the app' },
  { value: 'SUPPORT', label: 'Account / login issue' },
  { value: 'OTHER', label: 'Something else' },
];

// Returns the contact-us categories appropriate for the given role: patients
// get the reduced patient list, everyone else gets the full list.
export function getContactCategories(
  role: string | undefined,
): ReadonlyArray<{ value: ContactCategoryValue; label: string }> {
  return role === 'patient' ? PATIENT_CONTACT_CATEGORIES : CONTACT_CATEGORIES;
}
